/* @flow */
import getWindow from '@loggi/js/get-window';
import { getOptimizelyActiveExperiments } from './optimizely';
import type Optimizely from './optimizely';

export default function hotjar(event: string, args: any) {
  const $window = getWindow();
  if ($window !== null && $window.hj) {
    $window.hj(event, args);
    return true;
  }
  return false;
}

export function tagRecording(tags: Array<string>) {
  if (tags && tags.length > 0) {
    hotjar('tagRecording', tags);
  }
}

export function tagOptimizelyActiveExperiments() {
  const tagNames = [];

  getOptimizelyActiveExperiments().forEach(experiment => {
    tagNames.push(`Experiment: ${experiment.name}`);
    tagNames.push(`Variation: ${experiment.variation}`);
  });

  tagRecording(tagNames);
}

export function middleware(actionMapper: { [key: string]: string }) {
  return (store: Object) => (next: Function) => (action: Object) => {
    const eventName = actionMapper[action.type];
    if (eventName) {
      if (eventName) {
        const tags =
          typeof eventName === 'function'
            ? eventName(store.getState(), action)
            : [eventName];

        if (tags !== null) {
          tagRecording(tags);
        }
      }
      return next(action);
    }
    return null;
  };
}
